/* eslint-disable no-irregular-whitespace */ 

// LES IMAGES DE LA GALLERIE
let medias = [
   {
      title: "Bourbon-élagage-reunion-abbatage-cocotier",
      file_src: "1_Archive.jpg",
      file_type: 'jpg',
      file_alt: 'Bourbon-élagage-reunion-abbatage-cocotier',
      file_src_cover: '1_Archive_min.jpg',
      file_description: "Démontage d’un grand cocotier il y a très longtemps au Jardin de l’État à Saint-Denis, les cordes sont en cisal (matière végétal) !"
   },
     {
      title: "Bourbon-élagage-reunion-archive",
      file_src: "2_Archive_2.jpg",
      file_type: 'jpg',
      file_alt: 'Bourbon-élagage-reunion-archive',
      file_src_cover: '2-Archive-94-abattage-min.jpg',
      file_description: "Archive 1995:on pourrait se croire à Rio non? "
   },

   {
      title: "Bourbon-élagage-reunion-archive",
      file_src: "3_Archive_3.jpg",
      file_type: 'jpg',
      file_alt: 'Bourbon-élagage-reunion-archive',
      file_src_cover: '3-Archive-94-min.jpg',
      file_description: "Et oui, à l’époque pas de casque, pas de manchons, pas de pantalon de sécurité, pas de chaussures de sécurité, corde en cisal (ça se vendait au kilo ), même pas de gants…"
   },
 {
      title: "Bourbon-élagage-Tevelave-Réunion",
      file_src: "4_TEVELAVE.jpg",
      file_type: 'jpg',
      file_alt: 'Bourbon-élagage-Tevelave-Réunion',
      file_src_cover: '4-TEVELAVE-min.jpg',
      file_description: "Un métier d’équilibre. Des gants apparaissent, on progresse !"
   },
 {
      title: "Elagage-réunion-Cototier",
      file_src: "5_COCOTIER.jpg",
      file_type: 'jpg',
      file_alt: 'Elagage-réunion-Cototier',
      file_src_cover: '5-COCOTIER-min.jpg',
      file_description: "Le cocotier de Trou D’Eau, sur le site actuel de La Bodega."
   },
 {
      title: "Elagage-réunion-Cototier",
      file_src: "6_COCOTIER.jpg",
      file_type: 'jpg',
      file_alt: 'Elagage-réunion-Cototier',
      file_src_cover: '6-COCOTIER-min.jpg',
      file_description: "Le même. Des gants ! Un casque ! On avance encore dans le temps et la sécurité."
   },
 {
      title: "Caméléon-Élagage-reunion",
      file_src: "7_montravail.jpg",
      file_type: 'jpg',
      file_alt: 'Caméléon-Élagage-reunion',
      file_src_cover: '7-montravail-min.jpg',
      file_description: "Un endormi, très souvent rencontré dans les arbres ; on y fait très attention quand on en croise. Ah tiens  ! Des manchons anti coupures pour les bras !"
   },

 {
      title: "Élagage-reunion-eucalyptus",
      file_src: "8_EUCALYPTUS.jpg",
      file_type: 'jpg',
      file_alt: 'Élagage-reunion-eucalyptus',
      file_src_cover: '8-EUCALYPTUS-min.jpg',
      file_description: "Chantier sur un grand Eucalyptus au Tévelave (Eucalyptus Radiata)."
   },

 {
      title: "Elagage-Réunion-eucalyptus",
      file_src: "9_eucalyptus.jpg",
      file_type: 'jpg',
      file_alt: 'Elagage-Réunion-eucalyptus',
      file_src_cover: '9-eucalyptus-min.jpg',
      file_description: "Le même Eucalyptus ; la maison est très proche et le grimpeur tout petit."
   },

 {
      title: "Elagage-Réunion-Tamarin-Inde",
      file_src: "10_TAMARIN.jpg",
      file_type: 'jpg',
      file_alt: 'Elagage-Réunion-Tamarin-Inde',
      file_src_cover: '10-TAMARIN_min.jpg',
      file_description: "À deux dans le même arbre, en confiance !"
   },
 {
      title: "Elagage-Réunion-Tamarin-Inde",
      file_src: "11_TAMARIN_INDE.jpg",
      file_type: 'jpg',
      file_alt: 'Elagage-Réunion-Tamarin-Inde',
      file_src_cover: '11-TAMARIN_INDE-min.jpg',
      file_description: "Époque moderne : toute la panoplie de sécurité est présente, on ne rigole plus avec ça ; et le plaisir est toujours là ! "
   },


 {
      title: "Elagage-Réunion-Tamarin-Inde",
      file_src: "12_TAMARIN.jpg",
      file_type: 'jpg',
      file_alt: 'Elagage-Réunion-Tamarin-Inde',
      file_src_cover: '12-TAMARIN-min.jpg',
      file_description: "Pourquoi redescendre entre deux arbres ? Une tyrolienne et c'est moins de fatigue et  bien plus rapide."
   },

  // CA C'EST UN GIF
   // IL FAUT QU'IL SOIT LEGER TOUT DE MEME, NE PAS ABUSER 
   {
      title: "Démontage-Dattier-bourbon-elagage-reunion",
      file_src: "13_demontage_dattier.gif",
      file_type: 'gif',
      file_alt: 'Démontage-Dattier-bourbon-elagage-reunion',
      file_src_cover: '13_demontage_dattier_min.jpg',
      file_description: "Abattage d’un dattier pour notre partenaire EDF."
   },

{
      title: "Elagage-réunion-Sang-Dragon",
      file_src: "14-SANGDRAGON.jpg",
      file_type: 'jpg',
      file_alt: 'Elagage-réunion-Sang-Dragon',
      file_src_cover: '14-SANGDRAGON-min.jpg',
      file_description:"Un Sang Dragon avant... (Ptérocarpus Indicus)"
   },

{
      title: "Elagage-réunion-Sang-Dragon",
      file_src: "15_SANGDRAGON_2.jpg",
      file_type: 'jpg',
      file_alt: 'Elagage-réunion-Sang-Dragon',
      file_src_cover: '15-SANGDRAGON_2-min.jpg',
      file_description: "… et après. Le cadre et tout simplement magnifique, merci au propriétaire qui m’autorise la publication de ces photos."
   },

{
      title: "Elagage-réunion-arocaria",
      file_src: "16-AROCARIA.jpg",
      file_type: 'jpg',
      file_alt: 'Elagage-réunion-arocaria',
      file_src_cover: '16-AROCARIA-min.jpg',
      file_description: "Grand Pin Colonaire à deux têtes (Araucaria Columnaris) en bord de route."
   },

{
      title: "Elagage-réunion-Grand-Pin",
      file_src: "17_AROCARIA.jpg",
      file_type: 'jpg',
      file_alt: 'Elagage-réunion-Grand-Pin',
      file_src_cover: '17-AROCARIA-min.jpg',
      file_description: "Chacun sa tête, et toujours le travail en tandem."
   },

{
      title: "Abattage-rétention-bourbon-elagage-reunion",
      file_src: "18_ABATTAGE-TAMARIN.jpg",
      file_type: 'jpg',
      file_alt: 'Abattage-rétention-bourbon-elagage-reunion',
      file_src_cover: '18-ABATTAGE-TAMARIN-min.jpg',
      file_description: "Rétention d’un tronc ; « ce qui est en haut » : le grimpeur."
   },

{
      title: "Abattage-rétention-bourbon-elagage-reunion",
      file_src: "19_ABATTAGE-TAMARIN.jpg",
      file_type: 'jpg',
      file_alt: 'Abattage-rétention-bourbon-elagage-reunion',
      file_src_cover: '19_ABATTAGE-TAMARIN_min.jpg',
      file_description: "…« ce qui est en bas » : son binôme. La décontraction en surface n’empêche pas le sérieux, l’efficacité et le professionnalisme."
   },
{
      title: "Débittage-bourbon-elagage-reunion",
      file_src: "20_DEBITTAGE.jpg",
      file_type: 'jpg',
      file_alt: 'Débittage-bourbon-elagage-reunion',
      file_src_cover: '20-DEBITTAGE-min.jpg',
      file_description: "Troncs débités pour permettre leurs évacuations."
   },

{
      title: "terminalia-elagage-reunion",
      file_src: "21.jpg",
      file_type: 'jpg',
      file_alt: 'terminalia-elagage-reunion',
      file_src_cover: '21-min.jpg',
      file_description: "Série de photo sur l’élagage d’un Terminalia (Mentali) à l’institut Robert Debré à Saint-Gilles-les-Hauts."
   },
{
      title: "terminalia-elagage-reunion",
      file_src: "22.jpg",
      file_type: 'jpg',
      file_alt: 'terminalia-elagage-reunion',
      file_src_cover: '22-min.jpg',
      file_description: "Le même. L’institut est notre plus ancien client, la première facture datant de 1996 !"
   },
{
      title: "terminalia-elagage-reunion",
      file_src: "23.jpg",
      file_type: 'jpg',
      file_alt: 'terminalia-elagage-reunion',
      file_src_cover: '23-min.jpg',
      file_description: "Où est Charlie ? (Si on est attentif, il est au milieu) ."
   },

{
      title: "terminalia-elagage-reunion",
      file_src: "24.jpg",
      file_type: 'jpg',
      file_alt: 'terminalia-elagage-reunion',
      file_src_cover: '24-min.jpg',
      file_description: "Terminalia : Avant/Après"
   },
{
      title: "atelier-bourbon-elagage",
      file_src: "25_atelier.jpg",
      file_type: 'jpg',
      file_alt: 'atelier-bourbon-elagage',
      file_src_cover: '25-atelier-min.jpg',
      file_description: "La vue de l’atelier ; la mer, la montagne, les champs de canne : mieux qu’à la maison !"
   },

{
      title: "Kbis-bourbon-elagage",
      file_src: "26_insee1994.jpg",
      file_type: 'jpg',
      file_alt: 'Kbis-bourbon-elagage',
      file_src_cover: '26-insee1994-min.jpg',
      file_description: "Un des premiers Kbis de Bourbon Elagage : septembre 1994 ! Et toujours le même gérant ."
   },

{
      title: "bourbon-elagage-Nacelle",
      file_src: "27_NACELLE.jpg",
      file_type: 'jpg',
      file_alt: 'bourbon-elagage-Nacelle',
      file_src_cover: '27_NACELLE_min.jpg',
      file_description: "Elagage à la nacelle."
   },

   {
      // CA C'EST UNE VIDEO
      title: "les-mackes-la-reunion-elagage974",
      file_src: "https://www.youtube.com/embed/ECdnidW7bCA",
      file_type: 'mp4',
      file_alt: 'les-mackes-la-reunion-elagage974', 
      file_src_cover: '28_elico_min.jpg',
      file_description: "Lendemain de cyclone avec notre partenaire EDF, sympathique le moyen de transport."
   },

 
];

export default {medias}